// extracted by mini-css-extract-plugin
export default {"registerOnlyContainer":"RegisterOnly_registerOnlyContainer__hjmjK"};